import type { Config } from "./type";

const config: Config = {
  appUrl: "https://app.tuuuz.xyz",
  betterAuth: {
    scheme: "tuuuz",
  },
  futuresApiBaseUrl: "https://ex-api.tuuuz.xyz",
  betterAuthBaseUrl: "https://auth-api.tuuuz.xyz",
  // Telegram links use `telegram.me`, NOT the more familiar `t.me`: the .me
  // registry put t.me on serverHold on 2026-07-13, so it resolves to NXDOMAIN and
  // every t.me link is dead in a browser. telegram.me is Telegram's other
  // official domain, serves the same paths, and is unaffected.
  socialMediaLinks: [
    { platform: "x", alt: "X", href: "https://x.com/Tuuuz_Official" },
    {
      platform: "telegram",
      alt: "Telegram Channel",
      href: "https://telegram.me/Tuuuzofficial",
    },
    {
      platform: "instagram",
      alt: "Instagram",
      href: "https://www.instagram.com/tuuuzofficial1/",
    },
  ],
  zendeskKey: "8718a9e2-47f2-430d-99a9-00ff21f00500",
};

export default config;
